import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

export default function TabBar({ tabs, currentSelectedTab, _handleTabBar }) {
  const handleChange = (event, newValue) => {
    _handleTabBar(undefined, newValue);
  };

  return (
    <Box sx={{ width: "100%", backgroundColor: "#ffff" }}>
      <Tabs
        value={currentSelectedTab}
        onChange={handleChange}
        TabIndicatorProps={{
          style: {
            background: "black",
            color: "black",
            height: "4px",
          },
        }}
        aria-label="secondary tabs example"
      >
        {tabs.map((page) => (
          <Tab
            value={page}
            label={page}
            sx={{ color: "black", height: "30px" }}
          />
        ))}
      </Tabs>
    </Box>
  );
}
